<template>
	<div class="stream-display">
		<span class="pointer" @dblclick.stop="toggleBg">
			<img class="absolute pointer min-w-100 object-cover min-h-100" :class="{'z-index-min1': visibleElements.length === 0}" v-if="backgroundColor === '#FFFFFF' && !isBgToggled" :src="imgTransparentCheckerDark" alt="Grafias">
			<img class="absolute pointer min-w-100 object-cover min-h-100" :class="{'z-index-min1': visibleElements.length === 0}" v-if="backgroundColor === '#FFFFFF' && isBgToggled" :src="imgTransparentChecker" alt="Grafias" >
			<!-- boundarary -->
			<!-- <div v-show="heightDisplay > widthDisplay && heightDisplay < 1920" class="absolute z-index-99 pointer-events-none" :style="{width: `${(((heightDisplay / 9) * 16) - widthDisplay) / 2 }px`, height: `${heightDisplay}px`, backgroundColor: 'black'}"></div>
			<div v-show="heightDisplay > widthDisplay && heightDisplay < 1920" class="absolute z-index-99 pointer-events-none" :style="{width: `${(((heightDisplay / 9) * 16) - widthDisplay) / 2 }px`, height: `${heightDisplay}px`, backgroundColor: 'black', marginLeft: 'auto'}"></div> -->
			<div class="transition containerLogoGrafias">
				<span v-show="visibleElements.length === 0" @dblclick.stop="toggleBg" class="z-index-1">
					<span class="helper"></span>
					<img :src="activeBgColor" class="min-w-100 portrait-grafias-logo" alt="Grafias" style="vertical-align: middle;">
				</span>
			</div>
		</span>
		<transition-group name="transition">
			<div v-for="item in visibleElements" :key="item.id" :style="{ zIndex:item.layer_index }">
				<div :class="{'disabled': item.type === 'composition'}">
					<stream-element
						v-show="item.is_hidden === 0"
						:style="{ zIndex:item.layer_index }"
						:muted="isMuted"
						:status="type"
						:item="item"
						:key="item.id"
						>
					</stream-element>
				</div>
			</div>
		</transition-group>
	</div>
</template>

<script>
import $ from 'jquery';
import { mapActions } from 'vuex';
import dayjs from 'dayjs';
import { getAxiosErrorMessage, duplicateVar, delay } from '@/lib/helper';
import rundownItemsApi from '@/api/rundownItems';
import rundownsApi from '@/api/rundowns';
import atemApi from '@/api/atem';

import StreamElement from '@/components/StreamElement.vue';

export default {
	name: 'StreamDisplayLive',
	components: {
		StreamElement,
	},
	props: {
		type: {
			type: String,
			default: 'live',
		},
	},
	data() {
		return {
			rundown: {},
			items: [],
			whiteTransparentBg: '/img/logo/Grafias_FULLHD_White_transparent2.png',
			darkTransparentBg: '/img/logo/Grafias_FULLHD_Dark_transparent2.png',
			backgroundColor: '#FFFFFF',
			muted: false,
			imgTransparentChecker: '/img/checkertransparent_light.png',
			imgTransparentCheckerDark: '/img/checkertransparent_dark.png',
			isBgToggled: false,
			i: 0,
			j: 0,
			timeOuts: [],
			timeOut: null,
			// portrait
			widthDisplay: 0,
			heightDisplay: 0,
		};
	},
	sockets: {
		connect() {
			this.initSocket();
		},
		// item_update(item) {
		// 	this.insertItem(item);
		// },
		force_reset_item(item) {
			// this.insertItem(item);
			const content = item && item.content && typeof item.content === 'string' ? JSON.parse(item.content) : '';
			if (content) {
				if (content.customPageUrl !== '') {
					const iframe = document.getElementById(`page${item.slug}-${item.id}`);
					if (iframe) {
						// const rand = Math.floor((Math.random() * 1000000) + 1);
						iframe.src = `${content.customPageUrl}`;
					}
				}
			}
		},
		item_live_update(item) {
			this.insertItem(item);
		},
		items_live_update(items) {
			const filteredStartItems = items.filter(item => item.is_play_live || ((item.is_play_live && item.is_update_live && item.type === 'lower_third')));
			const filteredStopItems = items.filter(item => !item.is_play_live || ((item.is_play_live && !item.is_update_live && item.type === 'lower_third')));
			const lastItem = items && items.length > 0 ? duplicateVar(items[items.length - 1]) : null;
			const ultimateParent = lastItem && lastItem.isUltimateParent ? lastItem : null;
			if (filteredStartItems > 1 && ultimateParent) filteredStartItems.pop();

			const sortedStartItems = filteredStartItems.sort((a, b) => {
				const parsedA = JSON.parse(a.content);
				const parsedB = JSON.parse(b.content);
				return (parsedA.childOrder < parsedB.childOrder) ? -1 : 1;
			});
			for (let index = 0; index < filteredStopItems.length; index++) {
				const item = filteredStopItems[index];
				// find updated audio for fadeout
				const indexVisibleElement = this.visibleElements.findIndex(({ id }) => id === item.id);
				const idAudio = item.type === 'audio' && !item.is_play_live && this.visibleElements && this.visibleElements[indexVisibleElement] && this.visibleElements[indexVisibleElement].id;
				// insert item update
				this.insertItem(item, true, idAudio);
			}

			if (sortedStartItems.length > 0) {
				this.waitAndPlay(sortedStartItems, 0, lastItem);
			}
		},
		access_force_play_item(data) {
			this.insertItem(data, true);
			// updatelottieparamAccess
		},
		item_delete(id) {
			if (id) {
				this.removeItem(parseInt(id));
			}
		},
		rundown_stop(items) {
			this.onStopAll(items);
		},
		rundown_live_stop(items) {
			this.onStopAll(items);
		},
		rundown_background(item) {
			this.backgroundColor = item.background_color;
			$('html.md-theme-default').css('background-color', item.background_color);
		},
		item_bulk_delete(items) {
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				this.removeItem(item);
			}
		},
		item_mute_update(status) {
			this.muted = status;
		},
	},

	created() {
		this.initSocket();
		this.$nextTick(() => {
			$('body').css('background-color', 'transparent');
			$('html.md-theme-default').css('background-color', 'transparent');
			$(document).find('main').removeClass('main');
			$('html').css('overflow', 'hidden');
			this.setNavbarVisible(false);
			this.setDrawerVisible(false);
		});
		this.fetch();
	},
	destroyed() {
	},
	beforeDestroy() {
		this.leaveSocket();
		this.$nextTick(() => {
			$(document).find('main').addClass('main');
			$('body').css('background-color', '');
			$('html.md-theme-default').css('background-color', '');
			$('html').css('overflow', 'visible');
			this.setNavbarVisible(true);
			this.setDrawerVisible(true);
		});
	},
	mounted() {
		// update layout on each user publish new update
		window.addEventListener('message', this.receiveMessage, false);
	},
	methods: {
		// update layout on each user publish new update
		receiveMessage(e) {
			if (e.data === 'updateOutput') {
				this.fetch(false);
			}
		},
		...mapActions({
			setNavbarVisible: 'setNavbarVisible',
			setDrawerVisible: 'setDrawerVisible',
		}),
		sleep(ms) {
			return new Promise(resolve => setTimeout(resolve, ms));
		},
		waitAndPlay(items, i, lastItem) {
			const item = items && items.length > 0 ? items[i] : null;

			const nextItem = items && items.length > 0 && i < items.length - 1 ? items[i + 1] : null;
			if (item) this.insertItem(item);
			const itemContent = item && item.content ? item.content : '{}';
			const contentSortedStartItem = JSON.parse(itemContent);
			const childDuration = contentSortedStartItem && contentSortedStartItem.childOrder ? contentSortedStartItem.childOrder : 0;
			const ultimateParent = lastItem && lastItem.isUltimateParent ? lastItem : null;
			const ultimateParentContent = ultimateParent ? JSON.parse(ultimateParent.content) : null;
			const itemLength = items.length;
			const ultimateParentDuration = ultimateParentContent && ultimateParentContent.childOrder ? ultimateParentContent.childOrder : 0;
			let duration = childDuration < 0 ? (childDuration * -1) : childDuration;

			if (ultimateParent && item.id === ultimateParent.id) {
				if (nextItem) {
					const nextItemContent = nextItem && nextItem.content ? JSON.parse(nextItem.content) : '{}';
					const nextChildDuration = nextItemContent && nextItemContent.childOrder ? nextItemContent.childOrder : 0;
					if (nextChildDuration > ultimateParentDuration) {
						duration = nextChildDuration < 0 ? (nextChildDuration * -1) : nextChildDuration;
					}
				}
			}

			if (nextItem) {
				const nextItemContent = nextItem && nextItem.content ? JSON.parse(nextItem.content) : '{}';
				const nextChildDuration = nextItemContent && nextItemContent.childOrder ? nextItemContent.childOrder : 0;
				if (nextChildDuration === childDuration) {
					this.insertItem(nextItem);
					duration = 0;
				} else {
					// eslint-disable-next-line no-lonely-if
					if (childDuration > ultimateParentDuration) {
						duration = nextChildDuration < 0 ? (nextChildDuration * -1) : nextChildDuration;
					}
				}
			}
			const timeOut = setTimeout(() => { //  call a 3s setTimeout when the loop is called
				let indexInterval = i + 1;
				if (indexInterval < itemLength) { //  if the counter < 10, call the loop function
					this.waitAndPlay(items, indexInterval, lastItem); //  ..  again which will trigger another
				} //  ..  setTimeout()
				if (indexInterval === itemLength) {
					clearTimeout(timeOut);
					indexInterval = 0;
				}
			}, duration);
		},
		toggleBg() {
			this.isBgToggled = !this.isBgToggled;
		},
		hidden(item) {
			return item && item.is_hidden;
		},
		removeItem(itemId) {
			const index = this.items.findIndex(({ id }) => id === itemId);
			if (index !== -1) {
				this.items.splice(index, 1);
			}
		},
		initSocket() {
			this.$socket.client.emit('join', this.room);
		},
		leaveSocket() {
			this.$socket.client.emit('leave', this.room);
		},
		removeElement(item) {
			const element = document.getElementById(`${item.type}-${item.id}`);
			if (element) {
				element.remove();
			}
		},
		executeCustomCommand(stringCommand, parameter) {
			const callback = () => {

			};
			const errorCallback = () => {

			};
			let command = '';
			let paramInput = parameter;
			let finalCommand = `${command}(${paramInput})`;
			if (stringCommand === 'changeProgramInput') {
				command = 'atem.changeProgramInput';
			}
			if (stringCommand === 'runMacro') {
				command = 'atem.runMacro';
			}
			// if(stop_macros) command =`atem.changeInput`
			if (stringCommand === 'fadeToBlack') {
				command = 'atem.fadeToBlack';
				paramInput = '';
			}

			if (stringCommand === 'changeTransitionPosition') {
				command = 'atem.changeTransitionPosition';
			} // in percent 0 to 1
			if (stringCommand === 'changeTransitionType') {
				command = 'atem.changeTransitionType ';
			} // 0 = mix, 1=DIP, 2=WIPE
			if (stringCommand === 'cutTransition') {
				command = 'atem.cutTransition';
				paramInput = '';
			} // no input neededd
			if (stringCommand === 'autoTransition ') command = 'atem.autoTransition'; // no input neededd
			if (stringCommand === 'changeTransitionMix') command = 'atem.changeTransitionMix';
			if (stringCommand === 'changeAudioMasterGain') command = 'atem.changeAudioMasterGain';
			if (stringCommand === 'changeUpstreamKeyNextBackground') command = 'atem.changeUpstreamKeyNextBackground';
			if (stringCommand === 'changeAuxInput') command = 'atem.changeAuxInput';
			if (stringCommand === 'startRecordMacro') command = 'atem.startRecordMacro';
			if (stringCommand === 'stopRecordMacro') command = 'atem.stopRecordMacro';

			if (stringCommand === 'changeUpstreamKeyState') command = 'atem.changeUpstreamKeyState';

			if (stringCommand === 'changeUpstreamKeyNextState') command = 'atem.changeUpstreamKeyNextState';

			if (stringCommand === 'changeDownstreamKeyOn') command = 'atem.changeDownstreamKeyOn';
			if (stringCommand === 'changeDownstreamKeyTie') command = 'atem.changeDownstreamKeyTie';
			if (stringCommand === 'autoDownstreamKey') command = 'atem.autoDownstreamKey';

			if (stringCommand === 'changeAudioChannelGain') command = 'atem.changeAudioChannelGain';
			if (stringCommand === 'changeAudioChannelState') command = 'atem.changeAudioChannelState';


			finalCommand = `${command}(${paramInput})`;

			const params = {
				commands: finalCommand,
			};
			atemApi.execute(params, callback, errorCallback);
		},
		insertItem(item, reset = false, fadeoutAudioId = null) {
			const itemId = item && item.id ? item.id : null;
			const index = this.items.findIndex(({ id }) => id === itemId);
			if (index === -1) {
				if (item.type === 'custom_command') {
					const itemContent = duplicateVar(item.content);
					const parsedItemContent = JSON.parse(itemContent);
					const stringCommand = parsedItemContent.command;
					const parameter = parsedItemContent.customParameter;
					this.executeCustomCommand(stringCommand, parameter);
					this.items.push(item);
				} else {
					this.items.push(item);
				}
			} else {
				const isLowerThird = item.type === 'lower_third';
				const isCustomCommand = item.type === 'custom_command';
				const isItemCanUpdate = item.is_play_live;
				const currentItem = this.items[index];
				const currentItemUpdatedDate = dayjs(this.items[index].updated_at);
				const newItemUpdatedDate = dayjs(item.updated_at);
				const isItemNewer = newItemUpdatedDate.isAfter(currentItemUpdatedDate);
				if (isLowerThird) {
					if (!item.is_update_live && item.is_play_live) {
						const itemContent = duplicateVar(currentItem.content);
						const newItem = duplicateVar(item);
						newItem.content = itemContent;
						if (isItemNewer || reset) this.$set(this.items, index, newItem);
					} else {
						// eslint-disable-next-line no-lonely-if
						if (isItemNewer || reset) this.$set(this.items, index, item);
					}
				} else if (isCustomCommand && !isLowerThird) {
					// eslint-disable-next-line no-lonely-if
					const itemContent = duplicateVar(item.content);
					const parsedItemContent = JSON.parse(itemContent);
					const stringCommand = parsedItemContent.command;
					const parameter = parsedItemContent.customParameter;
					if (isItemCanUpdate) {
						if (isItemNewer || reset) this.executeCustomCommand(stringCommand, parameter);
						const itemContent = duplicateVar(item.content);
						const newItem = duplicateVar(item);
						newItem.content = itemContent;
						if (isItemNewer || reset) this.$set(this.items, index, newItem);
					} else {
						// eslint-disable-next-line no-lonely-if
						if (isItemNewer || reset) this.$set(this.items, index, item);
					}
				} else {
					// eslint-disable-next-line no-lonely-if
					if (!isItemCanUpdate) {
						const itemContent = duplicateVar(currentItem.content);
						const newItem = duplicateVar(item);
						newItem.content = itemContent;
						if (isItemNewer || reset) {
							// for non audio type assets
							if (!fadeoutAudioId) this.$set(this.items, index, item);
							// for audio type assets
							if (fadeoutAudioId) {
								delay(() => {
									this.$set(this.items, index, item);
								}, 1000);
							}
						}
					} else {
						// eslint-disable-next-line
						if (isItemNewer || reset) {
							// for non audio type assets
							if (!fadeoutAudioId) this.$set(this.items, index, item);
							// for audio type assets
							if (fadeoutAudioId) {
								delay(() => {
									this.$set(this.items, index, item);
								}, 1000);
							}
						}
					}
				}
			}
		},
		onStartPlay(item) {
			this.insertItem(item);
		},
		fetch(isReset = true) {
			const callback = (response) => {
				const rundown = response.data;
				this.rundown = rundown;
				this.heightDisplay = rundown && rundown.display && rundown.display.displaySize && rundown.display.displaySize.height ? parseInt(rundown.display.displaySize.height) : 0;
				this.widthDisplay = rundown && rundown.display && rundown.display.displaySize && rundown.display.displaySize.width ? parseInt(rundown.display.displaySize.width) : 0;
				if (this.rundown.background_color === 'transparent') this.rundown.background_color = '#FFFFFF';
				$('html.md-theme-default').css('background-color', this.rundown.background_color);
				if (isReset) this.fetchItems();
				this.setBackground();
			};
			const errorCallback = () => {

			};
			rundownsApi.getBySlug(this.slug, callback, errorCallback);
		},
		fetchItems() {
			const rundownId = this.rundown.id;
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'created_at',
				sort_by: 'desc',
				rundown_id: rundownId,
			};

			const callback = (response) => {
				const items = response.data;
				this.items = items;
				this.items.forEach((item) => {
					this.onStartPlay(item);
				});
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown Assets',
					text: message,
				});
			};
			rundownItemsApi.getList(params, callback, errorCallback);
		},
		onStopAll(items) {
			for (let index = 0; index < items.length; index++) {
				this.insertItem(items[index]);
			}
		},
		setBackground() {
			this.backgroundColor = this.rundown ? this.rundown.background_color : '#FFFFFF';
			if (this.backgroundColor === 'transparent') this.backgroundColor = '#FFFFFF';
		},
	},
	computed: {
		slug() {
			return atob(this.$route.params.slug);
		},
		isMuted() {
			return this.muted;
		},
		room() {
			const slug = atob(this.$route.params.slug);
			const room = `rundown_${slug}`;
			return room;
		},
		visibleElements() {
			const filter = item => (this.type === 'live' ? item && item.is_play_live === 1 : item.is_play_preview === 1);
			return this.items.filter(filter);
		},
		activeBgColor() {
			if (this.backgroundColor === '#FFFFFF' && !this.isBgToggled) return this.whiteTransparentBg;
			if (this.backgroundColor === '#FFFFFF' && this.isBgToggled) return this.darkTransparentBg;
			return this.backgroundColor === '#FFFFFF' || this.backgroundColor === '#00FF00' ? this.darkTransparentBg : this.whiteTransparentBg;
		},
	},
};
</script>

<style lang="scss">
html {
	-webkit-tap-highlight-color: transparent;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
}
.transition {
	position: absolute;
	-webkit-animation-name: transition;
	-webkit-animation-duration: .5s;
	animation-name: transition;
	animation-duration: .5s;
	}

	@keyframes transition {
	from {
		opacity : 0;
	}
	to {
		opacity : 1;
	}
}
</style>
